import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from "./components/App";

if (window.location.protocol === 'http:' && process.env.NODE_ENV === 'production') {
    window.location.href = window.location.href.replace('http://', 'https://');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <App/>
    </>
);


